export const Themes = {
  colors: {
    primary: `#8c6ff7`,
  },

  card: {
    backgroundColor: "rgba(68, 66, 178, 0.1)",
    boxShadow: "inset 0px 0px 0px 0.5px rgba(68, 66, 178, 0.2)",
  },
}

// #e2786c
// #8c6ff7

export const iPhoneResolution = 480
export const iPadResolution = 768
export const iPadProResolution = 1020

export const GlobalStyles = {
  insets: {
    pageTop: 140,
    pageTopMobile: 70,
  },

  borderRadius: 8,
}
